import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ["select", "container"]

  connect() {
    this.updatePreview()
  }

  updatePreview() {
    const selectedShape = this.selectTarget.value

    document.querySelectorAll('.mt-2').forEach(element => {
      element.classList.add("hidden")
    })

    if (selectedShape) {
      const selectedContainer = document.getElementById(selectedShape)
      if (selectedContainer) {
        selectedContainer.classList.remove("hidden")
      }
    }
  }
}
